import { isAiAssistantPage } from '@/utils/platformPages'
import { hasWebAction } from '@/utils/webAction'

export const AI_DRAFT_KEY = 'aiwb.preClassDraft'
export const AI_DRAFT_LIST_KEY = 'aiwb.drafts'
export const AI_SUBMITTED_KEY = 'aiwb.taskSubmitted'
export const NO_AI_PERMISSION_TEXT = '你所在的当前机构没有ai智能业务权限请联系管理员获取权限'
export const NEED_SELECT_MODULE_TEXT = '请选择你有的业务权限，其他问题无法回答'
export const NEED_SELECT_ACTION_TEXT = '请先选择要完成的操作功能'
export const OFF_TOPIC_TEXT = '你询问的事项无法回答。'
export const OFF_TOPIC_CONTINUE_TEXT = '请按下面业务清单继续操作。'
export const AI_QUOTA_TEXT = '你的ai智能服务token或资费已经用完，请联系管理员续费。'
export const AI_ADD_FORM_HINT =
  '已为你生成新增表单，查看确认直接点提交，也可自主修改或提出对教育内容字段的修改意见，重新为你生成内容。'
export const AI_TASK_FINISHED_EVENT = 'ai-task-finished'
export const DRAFT_ASK_AFTER_MS = 5 * 60 * 1000

let pendingAiJump = null

export function stashAiJump(jump) {
  pendingAiJump = jump && jump.type ? jump : null
}

export function takeAiJump() {
  const jump = pendingAiJump
  pendingAiJump = null
  return jump
}

const EDU_EXECUTE_STATUS = ['未执行', '已执行', '未整改', '已整改']
const STORAGE_PREFIX = 'smz.'

function readStorage(key) {
  try {
    const raw = window.localStorage.getItem(STORAGE_PREFIX + key)
    if (raw == null || raw === '') return ''
    try {
      return JSON.parse(raw)
    } catch (e) {
      return raw
    }
  } catch (e) {
    return ''
  }
}

function writeStorage(key, value) {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value))
  } catch (e) {
    void e
  }
}

function removeStorage(key) {
  try {
    window.localStorage.removeItem(STORAGE_PREFIX + key)
  } catch (e) {
    void e
  }
}

function orgType(org) {
  return (org && (org.vtype || org.vType || org.v_type)) || ''
}

/** 劳务公司上级标段 uid（业务字段对齐小程序；不改 Web 跳转交互） */
export function resolveLaborBidUid(org) {
  if (!org) return ''
  const direct =
    org.upbidSectionUid ||
    org.upBidSectionUid ||
    org.projectUid ||
    org.upVproUid ||
    ''
  if (direct) return String(direct)
  const upList = org.upOrg || []
  const hit =
    upList.find(
      (item) =>
        item &&
        item.professionalNature === '管控' &&
        item.professionalType === '直属标段'
    ) || upList.find((item) => item && item.professionalType === '直属标段')
  return (hit && (hit.orgUid || hit.uid)) || ''
}

/** 班前教育入库用的标段 orgUid */
export function resolveEduBidUid(org, fallback) {
  const t = orgType(org)
  if (t === 'laborCom') {
    return resolveLaborBidUid(org) || fallback || ''
  }
  return (org && org.orgUid) || fallback || ''
}

export function canAiHandleOrg(org) {
  const t = orgType(org)
  return t === 'simPro' || t === 'laborCom'
}

export function slimOrg(org) {
  if (!org) return {}
  const bid = resolveLaborBidUid(org)
  return {
    orgUid: org.orgUid,
    orgCode: org.orgCode,
    orgName: org.orgName || org.orgCode,
    vtype: org.vtype || org.vType,
    organType: org.organType || '',
    upbidSectionUid: bid || org.upbidSectionUid || org.upBidSectionUid || org.projectUid || '',
    projectUid: bid || org.projectUid || org.upbidSectionUid || org.upBidSectionUid || '',
    upOrg: org.upOrg || []
  }
}

function walkPages(pages, visit) {
  const list = pages || []
  for (let i = 0; i < list.length; i++) {
    const item = list[i]
    if (!item) continue
    if (visit(item)) return true
    if (item.children && item.children.length && walkPages(item.children, visit)) {
      return true
    }
  }
  return false
}

export function withOrgPages(org, userPages) {
  if (!org) return org
  if (org.pages && org.pages.length) return org
  const pageOrg = (userPages || []).find((item) => item && item.orgUid === org.orgUid)
  if (pageOrg && pageOrg.pages) {
    return Object.assign({}, org, { pages: pageOrg.pages })
  }
  return org
}

export function orgHasAiAssistant(org) {
  if (!org || !org.pages) return false
  return walkPages(org.pages, isAiAssistantPage)
}

export function collectAiApps(org) {
  if (!org || !org.pages) return []
  const apps = []
  const walk = (list, inAi) => {
    const rows = list || []
    rows.forEach((page) => {
      if (!page) return
      const isAi = isAiAssistantPage(page)
      if (isAi) {
        const children = page.children || []
        children.forEach((child) => {
          if (child) apps.push(child)
        })
      } else if (inAi) {
        apps.push(page)
      }
      if (page.children && page.children.length && !isAi) {
        walk(page.children, false)
      }
    })
  }
  walk(org.pages, false)
  return apps
}

export const AI_MODULES = [
  {
    code: 'preClass',
    name: '班前教育',
    enabled: true,
    match: (app) => {
      const name = (app && (app.pageName || (app.meta && app.meta.title))) || ''
      const path = (app && (app.pagePath || app.path)) || ''
      const code = (app && (app.name || app.pageCode)) || ''
      if (code === 'aiPreClass' || code === 'preClassEducation') return true
      if (path.indexOf('module=preClass') >= 0) return true
      if (name.indexOf('班前教育') < 0) return false
      if (path.indexOf('preClassCompany') >= 0 || path.indexOf('preClassBid') >= 0) return false
      if (name.indexOf('分析') >= 0) return false
      return true
    }
  }
]

function orgHasModule(org, module) {
  const apps = collectAiApps(org)
  if (apps.some((app) => module.match(app))) return true
  if (!orgHasAiAssistant(org)) return false
  return walkPages(org.pages, (page) => module.match(page))
}

export function collectAiModules(org) {
  if (!orgHasAiAssistant(org)) return []
  return AI_MODULES.filter((module) => module.enabled && orgHasModule(org, module)).map((module) => ({
    code: module.code,
    name: module.name,
    cover: require('@/assets/ai/peixun.png'),
    enabled: true
  }))
}

export function groupAiModules(modules) {
  const list = modules || []
  const groups = []
  for (let i = 0; i < list.length; i += 4) {
    groups.push(list.slice(i, i + 4))
  }
  return groups
}

export function collectAiOrgs(orgs, moduleCode) {
  const module = AI_MODULES.find((item) => item.code === moduleCode)
  if (!module) return []
  return (orgs || [])
    .filter((org) => orgHasModule(org, module) && canAiHandleOrg(org))
    .map((org) => ({
      id: org.orgUid,
      label: org.orgCode || org.orgName,
      subLabel: org.organType || '',
      org: slimOrg(org)
    }))
}

export function orgScopeQuery(org) {
  if (!org) return { orgUid: '', laborCompanyUid: '' }
  const vtype = orgType(org)
  if (vtype === 'laborCom') {
    return {
      orgUid: resolveLaborBidUid(org) || org.upbidSectionUid || org.orgUid,
      laborCompanyUid: org.orgUid
    }
  }
  return {
    orgUid: org.orgUid,
    laborCompanyUid: ''
  }
}

export function findOrg(allorgs, orgUid) {
  const list = allorgs || []
  return list.find((item) => item.orgUid === orgUid) || list[0] || null
}

export function orgDisplayName(org) {
  const text = String((org && (org.orgName || org.orgCode)) || '')
  const parts = text.split('/').filter(Boolean)
  return parts.length ? parts[parts.length - 1] : text
}

let memoryDraft = null

function usableDraft(draft) {
  if (!draft || typeof draft !== 'object') return null
  if (draft.trainingBrief || draft.teamUid || draft.workContent || draft.laborCompanyUid) return draft
  return null
}

export function loadAiDrafts() {
  const rows = readStorage(AI_DRAFT_LIST_KEY)
  if (!Array.isArray(rows) || !rows.length) return []
  return rows.slice(0, 1)
}

export function saveAiDraft(draft) {
  if (!draft) return
  writeStorage(AI_DRAFT_LIST_KEY, [{
    id: draft.id,
    moduleCode: draft.moduleCode || 'preClass',
    moduleName: draft.moduleName || '班前教育',
    orgUid: draft.orgUid,
    orgCode: draft.orgCode,
    updatedAt: Date.now(),
    draft: draft
  }])
}

export function removeAiDraft(id) {
  writeStorage(
    AI_DRAFT_LIST_KEY,
    loadAiDrafts().filter((item) => item.id !== id)
  )
}

export function clearAiDrafts() {
  removeStorage(AI_DRAFT_LIST_KEY)
}

export function markAiTaskSubmitted() {
  writeStorage(AI_SUBMITTED_KEY, '1')
}

export function consumeAiTaskSubmitted() {
  const flag = readStorage(AI_SUBMITTED_KEY)
  if (flag) removeStorage(AI_SUBMITTED_KEY)
  return !!flag
}

export function finishAiDraftIfNeeded() {
  if (!peekPreClassDraft() && !loadAiDrafts().length) return
  markAiTaskSubmitted()
  clearPreClassDraft()
  clearAiDrafts()
  try {
    window.dispatchEvent(new CustomEvent(AI_TASK_FINISHED_EVENT))
  } catch (e) {
    void e
  }
}

export function stashPreClassDraft(draft) {
  memoryDraft = draft && typeof draft === 'object' ? draft : null
  if (!memoryDraft) {
    removeStorage(AI_DRAFT_KEY)
    return
  }
  writeStorage(AI_DRAFT_KEY, memoryDraft)
}

export function peekPreClassDraft() {
  return usableDraft(memoryDraft) || usableDraft(readStorage(AI_DRAFT_KEY))
}

export function clearPreClassDraft() {
  memoryDraft = null
  removeStorage(AI_DRAFT_KEY)
}

export function parseTrainingVideos(value) {
  if (value == null || value === '') return []
  let list = []
  if (Array.isArray(value)) list = value
  else if (typeof value === 'string') {
    const text = value.trim()
    if (!text || text === '{}' || text === '[]' || text === 'null') return []
    try {
      const parsed = JSON.parse(text)
      if (Array.isArray(parsed)) list = parsed
      else if (parsed != null && parsed !== '') list = [String(parsed)]
    } catch (e) {
      list = [text]
    }
  }
  return list.map((item) => {
    if (item && typeof item === 'object') return item.uid || item.videoUid || ''
    return String(item || '').trim()
  }).filter(Boolean)
}

export function getEduExecuteStatus(row) {
  if (!row) return '未执行'
  const hasVideo = parseTrainingVideos(row.trainingVideos).length > 0
  const stored = String(row.executeStatus || row.execute_status || '').trim()
  const rectify =
    stored === '未整改' ||
    stored === '已整改' ||
    !!String(row.parentUid || row.parent_uid || '').trim()
  if (hasVideo) return rectify ? '已整改' : '已执行'
  return rectify ? '未整改' : '未执行'
}

function isSuperAdmin(user) {
  const name = (user && (user.name || user.userName || user.account || user.personName)) || ''
  return name === 'dpnadmin'
}

function getEduCreateOrgUid(row) {
  return (row && (row.createOrgUid || row.create_org_uid)) || ''
}

function isEduOwner(org, row, user) {
  if (isSuperAdmin(user)) return true
  const orgValue = (org && org.orgUid) || ''
  const creator = getEduCreateOrgUid(row)
  if (orgValue && creator && orgValue === creator) return true
  if (!orgValue || creator) return false
  if (orgType(org) === 'laborCom' && String((row && row.laborCompanyUid) || '') === orgValue) return true
  if (orgType(org) === 'simPro' && String((row && row.orgUid) || '') === orgValue) return true
  return false
}

function canEditEdu(org, row, user) {
  if (isSuperAdmin(user)) return true
  if (isEduOwner(org, row, user)) return true
  const orgValue = String((org && org.orgUid) || '')
  const data = row || {}
  const creator = String(getEduCreateOrgUid(data) || '')
  if (!orgValue || !creator || creator === orgValue) return false
  const bidUid = String(data.orgUid || '')
  const laborUid = String(data.laborCompanyUid || '')
  if (creator !== bidUid && creator !== laborUid) return false
  if (orgType(org) === 'simPro') return !bidUid || bidUid === orgValue
  return true
}

export function canOpenEduEdit(org, row, user) {
  const status = getEduExecuteStatus(row)
  if (status !== '未执行' && status !== '未整改') return false
  return canEditEdu(org, row, user)
}

function hasRectifyChild(row) {
  if (row && row._hasChildren) return true
  return ((row && row.children) || []).length > 0
}

export function canDeleteEdu(org, row, user) {
  if (isSuperAdmin(user)) return true
  const status = getEduExecuteStatus(row)
  if (status !== '未执行' && status !== '未整改') return false
  if (status === '未整改' && orgType(org) !== 'simPro' && orgType(org) !== 'com' && orgType(org) !== 'bigPro') return false
  if (hasRectifyChild(row)) return false
  return isEduOwner(org, row, user)
}

export function canRectifyEduRow(row) {
  const status = getEduExecuteStatus(row)
  if (status !== '已执行' && status !== '已整改') return false
  return !hasRectifyChild(row)
}

export function collectPreClassActions(org, state) {
  if (!org || !org.orgUid) return []
  return [
    { id: 'view', action: 'view', label: '查看' },
    { id: 'add', action: 'create', label: '新增' },
    { id: 'edit', action: 'edit', label: '编辑' },
    { id: 'delete', action: 'delete', label: '删除' },
    { id: 'sign', action: 'sign', label: '签到' },
    { id: 'upload', action: 'mediaEdit', label: '上传影像' },
    { id: 'rectify', action: 'rectify', label: '下达整改' }
  ]
    .filter((item) =>
      hasWebAction(state, `web:aiPreClass:${item.action}`)
    )
    .map((item) => ({
      id: item.id,
      type: 'action',
      label: item.label
    }))
}

/** 同班组今日已有未执行时的完整提示（与后台一致） */
export const PENDING_EDU_FULL_MSG =
  '当前班组已有今日待执行的班前教育数据，可直接去上传培训影像并签到，完成该数据之后才可再次创建新的班前教育数据。'

export function eduHasTrainingVideo(row) {
  return parseTrainingVideos(row && row.trainingVideos).length > 0
}

export function eduRowAllowedForAction(org, row, user, actionId) {
  if (!row || !actionId) return false
  if (actionId === 'edit') return canOpenEduEdit(org, row, user)
  if (actionId === 'delete') return canDeleteEdu(org, row, user)
  if (actionId === 'sign') {
    return getAttendanceCount(row) === 0
  }
  if (actionId === 'upload') {
    return !eduHasTrainingVideo(row)
  }
  if (actionId === 'rectify') return canRectifyEduRow(row)
  return false
}

export function eduActionEmptyText(actionId) {
  const map = {
    edit: '当前没有你有权编辑的班前教育。',
    delete: '当前没有你有权删除的班前教育。',
    sign: '当前没有可签到的班前教育。',
    upload: '当前没有可上传影像的班前教育。',
    rectify: '当前没有可下达整改的班前教育。'
  }
  return map[actionId] || '当前没有可操作的数据。'
}

export function eduActionListHint(actionId) {
  if (actionId === 'delete') {
    return '有以下符合的数据可供操作。请先点击查看确认无误，然后返回勾选点击删除。'
  }
  if (actionId === 'sign') {
    return '以下仅展示尚未有人签到的班前教育。请点击查看，在详情页完成签到。若需二次签到，请使用助手「查看」或进入应用列表切到「全部」找对应数据办理。'
  }
  if (actionId === 'upload') {
    return '以下仅展示尚未上传培训影像的班前教育。请点击查看，在详情页上传影像。若需上传多个影像，请使用助手「查看」或进入应用列表切到「全部」找对应数据办理。'
  }
  if (actionId === 'rectify') {
    return '有以下符合的数据可供操作。请点击查看详情确认无误，再点击右上角的整改按钮进入整改流程。'
  }
  return '有以下符合的数据可供操作。请先点击查看确认无误；教育内容以外的信息可自行修改后提交。如需重新生成教育内容，请返回勾选该记录，并提出修改意见，对话确认后再生成确认表单查看提交。'
}

export function eduActionListHintWeb(actionId) {
  if (actionId === 'delete') {
    return '有以下符合的数据可供操作。请先点击卡片打开详情确认无误，返回后勾选记录，再点击删除。'
  }
  if (actionId === 'sign') {
    return '以下仅展示尚未有人签到的班前教育。请勾选后打开签到。若需二次签到，请使用助手「查看」或进入应用列表切到「全部」找对应数据办理。'
  }
  if (actionId === 'upload') {
    return '以下仅展示尚未上传培训影像的班前教育。请勾选后打开上传。若需上传多个影像，请使用助手「查看」或进入应用列表切到「全部」找对应数据办理。'
  }
  if (actionId === 'edit') {
    return '有以下符合的数据可供操作。请先点击卡片打开编辑页核对，可自行修改；也可勾选后输入修改意见，生成内容会同步到编辑表单。同意直接提交，不同意请输入修改意见。'
  }
  if (actionId === 'rectify') {
    return '有以下符合的数据可供操作。请先点击卡片查看详情确认无误，返回后勾选记录，再点击下达整改。'
  }
  return '有以下符合的数据可供操作。请先点击卡片打开对应页面确认。'
}

/** 构造当日 00:00–次日 00:00 的查询区间（本地时区） */
export function todayTrainingTimeRange(dayValue) {
  const base = dayValue ? new Date(String(dayValue).replace(/-/g, '/')) : new Date()
  if (isNaN(base.getTime())) {
    return todayTrainingTimeRange()
  }
  const y = base.getFullYear()
  const m = ('0' + (base.getMonth() + 1)).slice(-2)
  const d = ('0' + base.getDate()).slice(-2)
  const day = y + '-' + m + '-' + d
  return [day + ' 00:00:00', day + ' 23:59:59']
}

export function isPendingEduRow(row) {
  return getEduExecuteStatus(row) === '未执行'
}

export function flattenEduTreeForView(rows, depth) {
  const level = depth || 0
  const out = []
  ;(rows || []).forEach((item) => {
    if (!item) return
    const kids = item.children || []
    const row = Object.assign({}, item)
    row._depth = level
    row._hasChildren = kids.length > 0
    out.push(row)
    if (kids.length) out.push.apply(out, flattenEduTreeForView(kids, level + 1))
  })
  return out
}

export function getAttendanceCount(row) {
  if (!row) return 0
  if (row.actualSignCount != null && Number(row.actualSignCount) > 0) return Number(row.actualSignCount)
  if (row.isDone != null && row.isDone !== '' && !isNaN(Number(row.isDone)) && EDU_EXECUTE_STATUS.indexOf(String(row.isDone)) < 0) {
    return Number(row.isDone)
  }
  if (row.checkInNum != null && row.checkInNum !== '') {
    const n = Number(row.checkInNum)
    if (!isNaN(n) && n >= 0) return n
  }
  const fallback = Number(row.attendanceCount)
  return isNaN(fallback) || fallback < 0 ? 0 : fallback
}

export function getCoverageRate(row) {
  const attendance = getAttendanceCount(row)
  const onSiteCount = Number((row && (row.onSiteCount || row.onsitecount)) || 0)
  if (onSiteCount > 0) return ((attendance / onSiteCount) * 100).toFixed(1) + '%'
  return attendance > 0 ? '100.0%' : '0.0%'
}

export function statusTagClass(status) {
  if (status === '已执行') return 'success-tag'
  if (status === '已整改') return 'warn-tag'
  return 'fail-tag'
}

export function videoLabel(row) {
  const n = parseTrainingVideos(row && row.trainingVideos).length
  return n ? n + '个影像' : '暂无影像'
}

export function videoTagClass(row) {
  return parseTrainingVideos(row && row.trainingVideos).length ? 'success-tag' : 'fail-tag'
}

export function fillWorkFromEduBrief(form, brief) {
  if (!form) return false
  const text = String(brief != null ? brief : form.trainingBrief || '')
  const titles = text.match(/^\d+、[\s\S]*?：$/gm)
  if (!titles || !titles.length) return false
  const workContents = titles
    .map((item) => String(item).replace(/^\d+、/, '').replace(/：$/, '').trim())
    .filter(Boolean)
  if (!workContents.length) return false
  form.workContents = workContents
  form.workContent = workContents.join('；\n')
  return true
}

export function currentUserUid() {
  try {
    const token = window.sessionStorage.getItem('token') || ''
    const parts = token.split('.')
    if (parts.length < 2) return ''
    const json = JSON.parse(
      decodeURIComponent(
        escape(
          window.atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
        )
      )
    )
    return json.uid || json.userUid || json.user_uid || json.sub || ''
  } catch (e) {
    return ''
  }
}
